import ExpertFeedStore from '@anywhere-expert/expert-feed-store/ExpertFeedStore';

export const useTimelineSearchStore = () => {
    return ExpertFeedStore.selectedSupportSession!.timelineSearchStore;
};
